import { WIDTH_LOGO_ICON, HEIGHT_LOGO_ICON } from '@/configuration/general/iconMarkerConf';

// Permet de créer le carré avec la petite flèche
function roundRect(context, x, y, w, radius) {
  const h = w;
  const r = x + w;
  const b = y + h;
  context.beginPath();
  context.strokeStyle = 'green';
  context.lineWidth = '4';
  context.moveTo(x + radius, y);
  context.lineTo(r - radius, y);
  context.quadraticCurveTo(r, y, r, y + radius);
  context.lineTo(r, y + h - radius);
  context.quadraticCurveTo(r, b, r - radius, b);
  context.lineTo(x + radius, b);
  context.quadraticCurveTo(x, b, x, b - radius);
  context.lineTo(x, y + radius);
  context.quadraticCurveTo(x, y, x + radius, y);
  context.fill();
}

export default function getDataUrl(img, color = '#000000') {
  const canvas = document.createElement('canvas');
  canvas.width = WIDTH_LOGO_ICON;
  canvas.height = HEIGHT_LOGO_ICON;
  const ctx = canvas.getContext('2d');
  const radius = 0;
  const coteCarre = WIDTH_LOGO_ICON - 2 * radius;
  ctx.fillStyle = color;
  roundRect(ctx, radius, radius, coteCarre, radius);
  ctx.beginPath();
  ctx.moveTo(WIDTH_LOGO_ICON / 2 - 6, WIDTH_LOGO_ICON);
  ctx.lineTo(WIDTH_LOGO_ICON / 2, HEIGHT_LOGO_ICON);
  ctx.lineTo(WIDTH_LOGO_ICON / 2 + 6, HEIGHT_LOGO_ICON - (HEIGHT_LOGO_ICON - WIDTH_LOGO_ICON));
  ctx.closePath();
  ctx.fill();
  const border = 2;
  ctx.drawImage(img, 0, 0, img.naturalWidth, img.naturalHeight, border, border,
    WIDTH_LOGO_ICON - border * 2, WIDTH_LOGO_ICON - border * 2);
  return canvas.toDataURL('image/png');
}
